webpackJsonp([91],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchMasRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return freezeFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return newUserConfigRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newbieMissionConfigRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  call_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通类型', 'integer'))],
  communicate_detail: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择记录详情', 'integer'))],
  record_detail: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通详情', 'string'))],
  communicate_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通方式', 'integer'))]

};

var searchMasRules = {
  type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择群发消息', 'integer'))],
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入消息标题', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到30个字符'), { min: 1, max: 30 })],
  content: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入消息内容', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到300个字符'), { min: 1, max: 300 })]
};

var formRules = {
  cellphone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入手机号', 'string'))]
};

var freezeFormRules = {
  freeze_status: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择封号状态', 'integer'))],
  freeze_reason: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择封号原因', 'integer'))],
  freeze_reason_desc: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入封号原因'))]

};

var newUserConfigRules = {
  condition_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择条件类型', 'string'))]
};

var newbieMissionConfigRules = {
  'watch_tutorial_video.video_url': [{ required: true, message: '请选择教程视频', trigger: 'change' }],
  'watch_tutorial_video.img_url': [{ required: true, message: '请上传教程视频封面', trigger: 'change' }],
  'finish_newbie_task.task_id': [{ required: true, message: '请选择一个新手任务', trigger: 'change' }]
};

/***/ }),

/***/ 3105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_rules__ = __webpack_require__(1670);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false,
      newUserConfigRules: __WEBPACK_IMPORTED_MODULE_1__users_rules__["c" /* newUserConfigRules */],
      conditionIdCounter: 1,
      form: {
        condition_type: 'all',
        conditions: [{
          id: 0,
          type: '',
          operator: 'lte',
          value: ''
        }]
      },
      conditionOptions: [{ value: 'register_days', label: '注册时长', unit: '天' }, { value: 'finished_task_count', label: '完成任务数', unit: '个' }, { value: 'total_reward', label: '累计获得赏金', unit: '元' }]
    };
  },
  created: function created() {
    // 预构建校验规则缓存，避免每次渲染创建新对象
    var integerValidator = function integerValidator(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入数值'));
        return;
      }
      var num = Number(value);
      if (isNaN(num)) {
        callback(new Error('请输入有效的数字'));
        return;
      }
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(num)) {
        callback(new Error('请输入整数'));
        return;
      }
      if (num <= 0) {
        callback(new Error('数值必须是正数'));
        return;
      }
      callback();
    };
    var amountValidator = function amountValidator(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入数值'));
        return;
      }
      // 校验金额格式：整数或最多两位小数，拒绝 "."、".5"、"10." 等不规范格式
      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('请输入有效的金额，最多两位小数'));
        return;
      }
      var num = Number(value);
      if (num <= 0) {
        callback(new Error('金额必须大于0'));
        return;
      }
      callback();
    };
    var integerRules = [{ required: true, message: '请输入数值' }, { validator: integerValidator, trigger: 'blur' }];
    var amountRules = [{ required: true, message: '请输入数值' }, { validator: amountValidator, trigger: 'blur' }];
    var defaultRules = [{ required: true, message: '请输入数值' }];
    this._valueRulesCache = {
      register_days: integerRules,
      finished_task_count: integerRules,
      total_reward: amountRules,
      '': defaultRules
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },

  computed: {
    isViewPage: function isViewPage() {
      return this.$route.meta.pageType === 'view';
    },
    // 为每个条件行计算可用的选项（已选条件置灰）
    conditionOptionsMap: function conditionOptionsMap() {
      var conditions = this.form.conditions;
      var options = this.conditionOptions;
      return conditions.map(function (condition) {
        return options.map(function (option) {
          return {
            value: option.value,
            label: option.label,
            unit: option.unit,
            disabled: conditions.some(function (c) {
              return c.type === option.value && c.type !== condition.type;
            })
          };
        });
      });
    },
    // 根据条件类型映射校验规则
    valueRulesMap: function valueRulesMap() {
      return this._valueRulesCache || {};
    }
  },
  methods: {
    onLoad: function onLoad() {
      this.getConfig();
    },
    getConfig: function getConfig() {
      var _this = this;

      var initLoading = this.$loading({ text: '配置拉取中...', lock: true });
      request.common('getNewbieDefineCondApi', {}).then(function (_ref) {
        var data = _ref.data;

        var config = _.get(data, 'value.config', null);
        if (config) {
          _this.form.condition_type = config.condition_type || 'all';

          var self = _this;
          var defaultCondition = { id: self.conditionIdCounter++, type: '', operator: 'lte', value: '' };
          var loadedConditions = Array.isArray(config.conditions) && config.conditions.length > 0 ? config.conditions.map(function (c) {
            return {
              id: self.conditionIdCounter++,
              type: c.type || '',
              operator: c.operator || 'lte',
              value: c.value !== undefined && c.value !== null ? String(c.value) : ''
            };
          }) : [defaultCondition];

          _this.$set(_this.form, 'conditions', loadedConditions);
        }
      }).catch(function () {
        _this.$message.error('配置拉取失败，请刷新页面');
      }).finally(function () {
        initLoading.close();
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (!filter.hasPermission(20001)) {
        this.$alert('您没有保存 新用户定义配置 的权限');
        return;
      }

      this.$refs.configForm.validate(function (valid) {
        if (valid) {
          if (_this2.form.conditions.some(function (c) {
            return !c.type;
          })) {
            _this2.$message.error('请为所有条件选择条件类型');
            return;
          }
          _this2.saveConfig();
        } else {
          _this2.$message.error('表单填写不正确，请检查');
        }
      });
    },
    saveConfig: function saveConfig() {
      var _this3 = this;

      var self = this;
      var params = {
        config: {
          condition_type: this.form.condition_type,
          conditions: this.form.conditions.map(function (condition) {
            return {
              type: condition.type,
              operator: condition.operator,
              value: condition.value,
              unit: self.getUnit(condition.type)
            };
          })
        }
      };
      this.isSaving = true;
      request.common('setNewbieDefineCondApi', params).then(function () {
        _this3.$alert('配置保存成功');
      }).catch(function () {
        _this3.$message.error('配置保存失败');
      }).finally(function () {
        _this3.isSaving = false;
      });
    },
    addCondition: function addCondition() {
      if (this.form.conditions.length >= 3) {
        this.$message.warning('最多只能添加3个条件');
        return;
      }
      this.form.conditions.push({
        id: this.conditionIdCounter++,
        type: '',
        operator: 'lte',
        value: ''
      });
    },
    removeCondition: function removeCondition(index) {
      var _this4 = this;

      if (this.form.conditions.length <= 1) {
        this.$message.warning('至少需要保留一个条件');
        return;
      }
      this.form.conditions.splice(index, 1);
      this.$nextTick(function () {
        _this4.$refs.configForm.clearValidate();
      });
    },
    handleConditionTypeChange: function handleConditionTypeChange(condition, index) {
      var _this5 = this;

      condition.value = '';
      this.$nextTick(function () {
        if (_this5.$refs.configForm) {
          _this5.$refs.configForm.clearValidate('conditions.' + index + '.value');
        }
      });
    },
    getUnit: function getUnit(type) {
      var option = this.conditionOptions.find(function (opt) {
        return opt.value === type;
      });
      return option ? option.unit : '';
    }
  }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersNewbieCfg_vue__ = __webpack_require__(3105);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_548b4e76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersNewbieCfg_vue__ = __webpack_require__(5847);
function injectStyle (ssrContext) {
  __webpack_require__(5845)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-548b4e76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersNewbieCfg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_548b4e76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersNewbieCfg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5845:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5846);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0e7156a0", content, true, {});

/***/ }),

/***/ 5846:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".config-container[data-v-548b4e76]{padding:10px 20px}.config-container .config-form[data-v-548b4e76]{max-width:800px}.config-container .config-notes[data-v-548b4e76]{margin-top:15px}.config-container .config-notes .notes-content[data-v-548b4e76]{font-size:13px;line-height:1.6;color:#606266}.config-container .config-notes .notes-content p[data-v-548b4e76]{margin:0}.condition-list[data-v-548b4e76]{margin:10px 0}.condition-item[data-v-548b4e76]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px;padding:8px 10px;background-color:#f5f7fa;border-radius:4px}.condition-item .condition-number[data-v-548b4e76]{font-size:14px;color:#606266;font-weight:500;width:18px}.condition-item .condition-form-item[data-v-548b4e76]{margin-bottom:0}.condition-item .condition-select[data-v-548b4e76],.condition-item .operator-select[data-v-548b4e76],.condition-item .value-input[data-v-548b4e76]{width:100%}.condition-item .unit-label[data-v-548b4e76]{font-size:14px;color:#606266;min-width:20px;margin-left:2px}.condition-item .delete-btn[data-v-548b4e76]{padding:0;margin-left:5px}.condition-text[data-v-548b4e76]{margin-left:8px;color:#606266}", "", {"version":3,"sources":["/workspace/src/views/users/pages/UsersNewbieCfg.vue"],"names":[],"mappings":"AACA,mCAAmC,iBAAiB,CACnD,AACD,gDAAgD,eAAe,CAC9D,AACD,iDAAiD,eAAe,CAC/D,AACD,gEAAgE,eAAe,gBAAgB,aAAa,CAC3G,AACD,kEAAkE,QAAQ,CACzE,AACD,iCAAiC,aAAa,CAC7C,AACD,iCAAiC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,kBAAkB,iBAAiB,yBAAyB,iBAAiB,CAC5O,AACD,mDAAmD,eAAe,cAAc,gBAAgB,UAAU,CACzG,AACD,sDAAsD,eAAe,CACpE,AAKD,mJAA8C,UAAU,CACvD,AACD,6CAA6C,eAAe,cAAc,eAAe,eAAe,CACvG,AACD,6CAA6C,UAAU,eAAe,CACrE,AACD,iCAAiC,gBAAgB,aAAa,CAC7D","file":"UsersNewbieCfg.vue","sourcesContent":["\n.config-container[data-v-548b4e76]{padding:10px 20px\n}\n.config-container .config-form[data-v-548b4e76]{max-width:800px\n}\n.config-container .config-notes[data-v-548b4e76]{margin-top:15px\n}\n.config-container .config-notes .notes-content[data-v-548b4e76]{font-size:13px;line-height:1.6;color:#606266\n}\n.config-container .config-notes .notes-content p[data-v-548b4e76]{margin:0\n}\n.condition-list[data-v-548b4e76]{margin:10px 0\n}\n.condition-item[data-v-548b4e76]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px;padding:8px 10px;background-color:#f5f7fa;border-radius:4px\n}\n.condition-item .condition-number[data-v-548b4e76]{font-size:14px;color:#606266;font-weight:500;width:18px\n}\n.condition-item .condition-form-item[data-v-548b4e76]{margin-bottom:0\n}\n.condition-item .condition-select[data-v-548b4e76]{width:100%\n}\n.condition-item .operator-select[data-v-548b4e76]{width:100%\n}\n.condition-item .value-input[data-v-548b4e76]{width:100%\n}\n.condition-item .unit-label[data-v-548b4e76]{font-size:14px;color:#606266;min-width:20px;margin-left:2px\n}\n.condition-item .delete-btn[data-v-548b4e76]{padding:0;margin-left:5px\n}\n.condition-text[data-v-548b4e76]{margin-left:8px;color:#606266\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5847:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('div',{staticClass:"config-container"},[_c('div',{staticClass:"config-form"},[_c('el-form',{ref:"configForm",attrs:{"model":_vm.form,"rules":_vm.newUserConfigRules,"size":"small"}},[_c('el-form-item',{attrs:{"label":"符合以下","prop":"condition_type"}},[_c('el-select',{staticStyle:{"width":"120px"},attrs:{"placeholder":"请选择条件类型","disabled":_vm.isViewPage},model:{value:(_vm.form.condition_type),callback:function ($$v) {_vm.$set(_vm.form, "condition_type", $$v)},expression:"form.condition_type"}},[_c('el-option',{attrs:{"label":"所有","value":"all"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"任一","value":"any"}})],1),_vm._v(" "),_c('span',{staticClass:"condition-text"},[_vm._v("条件")])],1),_vm._v(" "),_c('div',{staticClass:"condition-list"},_vm._l((_vm.form.conditions),function(condition,index){return _c('div',{key:condition.id,staticClass:"condition-item"},[_c('span',{staticClass:"condition-number"},[_vm._v(_vm._s(index + 1)+".")]),_vm._v(" "),_c('el-form-item',{staticClass:"condition-form-item",attrs:{"prop":("conditions." + index + ".type"),"rules":{required: true, message: '请选择条件'}}},[_c('el-select',{staticClass:"condition-select",attrs:{"placeholder":"请选择条件","disabled":_vm.isViewPage},on:{"change":function($event){return _vm.handleConditionTypeChange(condition, index)}},model:{value:(condition.type),callback:function ($$v) {_vm.$set(condition, "type", $$v)},expression:"condition.type"}},_vm._l((_vm.conditionOptionsMap[index]),function(opt){return _c('el-option',{key:opt.value,attrs:{"label":opt.label,"value":opt.value,"disabled":opt.disabled}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"condition-form-item",attrs:{"prop":("conditions." + index + ".operator"),"rules":{required: true, message: '请选择运算符'}}},[_c('el-select',{staticClass:"operator-select",attrs:{"disabled":_vm.isViewPage},model:{value:(condition.operator),callback:function ($$v) {_vm.$set(condition, "operator", $$v)},expression:"condition.operator"}},[_c('el-option',{attrs:{"label":"小于","value":"lt"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"等于","value":"eq"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"大于","value":"gt"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"小于等于","value":"lte"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"大于等于","value":"gte"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"condition-form-item",attrs:{"prop":("conditions." + index + ".value"),"rules":_vm.valueRulesMap[condition.type]}},[_c('el-input',{staticClass:"value-input",attrs:{"disabled":_vm.isViewPage,"placeholder":"请输入数值"},model:{value:(condition.value),callback:function ($$v) {_vm.$set(condition, "value", $$v)},expression:"condition.value"}})],1),_vm._v(" "),_c('span',{staticClass:"unit-label"},[_vm._v(_vm._s(_vm.getUnit(condition.type)))]),_vm._v(" "),(_vm.form.conditions.length > 1 && !_vm.isViewPage)?_c('el-button',{staticClass:"delete-btn",attrs:{"type":"text","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeCondition(index)}}},[_vm._v("删除\n              ")]):_vm._e()],1)}),0),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus","size":"small","disabled":_vm.form.conditions.length >= 3 || _vm.isViewPage,"plain":""},on:{"click":_vm.addCondition}},[_vm._v("添加条件\n            ")]),_vm._v(" "),(!_vm.isViewPage)?_c('el-button',{attrs:{"type":"success","size":"small","loading":_vm.isSaving},on:{"click":_vm.onSubmit}},[_vm._v("保存配置\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"config-notes"},[_c('el-alert',{attrs:{"title":"配置说明","type":"info","closable":false,"show-icon":""}},[_c('div',{staticClass:"notes-content"},[_c('p',[_vm._v("• 用户需要满足此处配置的规则才会被判定为新手")]),_vm._v(" "),_c('p',[_vm._v("• 每个条件类型只能选择一次")]),_vm._v(" "),_c('p',[_vm._v("• 最多可添加3个条件")]),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v("* 注：所有带了“排他标签”的用户，都不算新用户")])])])],1)],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/users-newbie-cfg.a6b577f2380d66971aa3.js